import {
  ACCOUNT_COLUMNS,
  AGENT_COLUMNS,
  CONTACT_COLUMNS,
  FEEDBACK_COLUMNS,
  SENTIMENT_COLUMNS,
  SOURCE_COLUMNS,
} from '@/types/filterKeyConst';

export const initial_column_configs: Record<
  VIEW_CATEGORY,
  ColumnConfigsResT[]
> = {
  feedback_view: [
    {
      name: FEEDBACK_COLUMNS.COMPNAY,
      width: 120,
      visible: true,
    },
    {
      name: FEEDBACK_COLUMNS.CUSTOMER,
      width: 120,
      visible: true,
    },
    {
      name: FEEDBACK_COLUMNS.TITLE,
      width: 600,
      visible: true,
    },
    {
      name: FEEDBACK_COLUMNS.CATEGORY,
      width: 200,
      visible: true,
    },
    {
      name: FEEDBACK_COLUMNS.TAG,
      width: 200,
      visible: true,
    },
    {
      name: SENTIMENT_COLUMNS.KEY_SENTIMENT,
      width: 120,
      visible: true,
    },
    {
      name: SENTIMENT_COLUMNS.ENDING_SENTIMENT,
      width: 140,
      visible: true,
    },
    {
      name: SOURCE_COLUMNS.SOURCE_TYPE,
      width: 140,
      visible: true,
    },
    {
      name: SOURCE_COLUMNS.DATA_ORIGIN,
      width: 140,
      visible: true,
    },
    {
      name: FEEDBACK_COLUMNS.DATE,
      width: 140,
      visible: true,
    },
    {
      name: FEEDBACK_COLUMNS.AGENT,
      width: 140,
      visible: true,
    },
    {
      name: FEEDBACK_COLUMNS.TICKET_STATUS,
      width: 120,
      visible: true,
    },
  ].map((config, index) => ({
    ...config,
    order: index,
  })),
  account_view: [
    {
      name: ACCOUNT_COLUMNS.INDUSTRY,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.EMPLOYEE_COUNT,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.SIZE,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.MONTHLY_SPEND,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.ANNUAL_REVENUE,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.PLAN,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.RATING,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.TYPE,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.COUNTRY,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.FEEDBACK_COUNT,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.ACTIVE_STATUS,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.CREATED_AT,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.LAST_ACTIVITY,
      width: 200,
      visible: true,
    },
    {
      name: ACCOUNT_COLUMNS.MANAGER,
      width: 200,
      visible: true,
    },
  ].map((config, index) => ({
    ...config,
    order: index,
  })),
  contact_view: [
    {
      name: CONTACT_COLUMNS.ACCOUNT,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.SENTIMENT,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.JOB_FUNCTION,
      width: 200,

      visible: true,
    },
    {
      name: CONTACT_COLUMNS.EMAIL,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.PHONE,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.DESC,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.REFERENCE_LINK,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.COUNTRY,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.TYPE,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.PLAN,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.STAGE,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.MRR,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.MANAGER,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.FEEDBACK_COUNT,
      width: 200,
      visible: true,
    },
    {
      name: CONTACT_COLUMNS.LAST_ACTIVITY,
      width: 200,
      visible: true,
    },
  ].map((config, index) => ({
    ...config,
    order: index,
  })),
  agent_view: [
    {
      name: AGENT_COLUMNS.NAME,
      width: 200,
      visible: true,
    },
    {
      name: AGENT_COLUMNS.ROLE,
      width: 200,
      visible: true,
    },
    {
      name: AGENT_COLUMNS.EMAIL,
      width: 200,
      visible: true,
    },
  ].map((config, index) => ({
    ...config,
    order: index,
  })),
};
